export default function Footer(): JSX.Element {
    return (
        <div
            style={{
                backgroundColor: `#039876`
            }}
            className="py-6"
        >
            <div className='mx-6 md:mx-12 p-6'>
                <hr />
            </div>
        </div>
    )
}